// ClientAddress.type_address: 1 = fiscal (managed from admin-panel), 2 = agency (public).
export const AGENCY_ADDRESS_TYPE = 2;

// The public profile uses the most recent active agency address, so Panel PRO shows and edits that one.
export function getAgencyAddress(addresses) {
  return (addresses ?? [])
    .filter((address) => Number(address.type_address) === AGENCY_ADDRESS_TYPE)
    .reduce((latest, address) => (!latest || address.id > latest.id ? address : latest), undefined);
}
